"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _canalPro = _interopRequireDefault(require("./assets/canal-pro"));
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function ProzapHeader() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Header, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_canalPro["default"], {
        style: {
          width: '140px',
          height: '22px'
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Title, {
      children: "Atendimento"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Menu, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MenuItemLink, {
        href: "https://canalpro.grupozap.com/ZAP_OLX/0/leads/messages",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MenuItem, {
          children: "Mensagens"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MenuItemSelected, {
        children: "Chat"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MenuItemLink, {
        href: "https://canalpro.grupozap.com/ZAP_OLX/0/leads/calls",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MenuItem, {
          children: "Liga\xE7\xF5es"
        })
      })]
    })]
  });
}
var _default = exports["default"] = ProzapHeader;